// oxlint-disable-next-line graphql-relay-compat/no-interop-imports -- see https://go.atlassian.com/cfe-no-interop-imports
import type { ApolloErrorInterop } from '@confluence/apollo-relay-interop-utils/entry-points/ApolloErrorInterop.ts';

import { containsNetworkError } from '@confluence/network';
import { isUnauthorizedError } from '@confluence/error-boundary/entry-points/isUnauthorizedError.ts';

export function isExpectedError(error: ApolloErrorInterop): boolean {
	const isUnauthorized =
		error?.graphQLErrors?.[0]?.message === 'unauthorized' || isUnauthorizedError(error);

	return isUnauthorized || containsNetworkError(error);
}
